import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-submit-alert',
    templateUrl: './submitAlert.component.html',
    styleUrls: ['./submitAlert.component.css']
  })

export class SubmitAlertComponent{

}